import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingChange';

import { decline } from './utils';

export default function* listenDecline() {
  yield takeEvery(actions.decline.toString(), decline);
}
